export const getLocale = (locale: string): string =>
  (locale ?? '').replace(/-[a-z]{2}XxX[a-z]{2}$/, '')
